import React, { Component } from 'react';
import AliceCarousel from 'react-alice-carousel';
import banner1 from '../../public/banner-1.jpg';
import banner2 from '../../public/banner-2.jpg';
import banner3 from '../../public/banner-3.jpg';
export default class HeroBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {

      responsive: {
        0: { items: 1 },
        568: { items: 1 },
        1024: { items: 1 },
      },
    };

  }

  render() {
    const { responsive } = this.state;
    const { data } = this.props;
    const sliders = data.map((item, index) =>
      <section className="hero" style={{ backgroundImage: `url(${item?.image})` }} key={index}>
        <div className="container">
          <div className="row">
            <div className="col-md-8">&nbsp;</div>
            <div className="col-md-4">
              <div className="heroInfo">
                <h1 className="fw-bold ">{item?.post_title}</h1>
                <p className=''>{item?.post_content}</p>
                <button className="btn btn-outline-light rounded-5 ">Read More</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
    return (
      <AliceCarousel
        animationType='slide'
        autoPlayInterval={2000}
        autoWidth={false}
        autoPlay={true}
        autoPlayStrategy="all"
        controlsStrategy="responsive"
        disableDotsControls
        disableAutoPlayOnAction={true}
        items={sliders}
        responsive={responsive}
        mouseTracking
        touchTracking
        infinite
        mouseTrackingEnabled={true}
        // autoHeight={true}
        disableButtonsControls={true}
      />
    );
  }
}
